<template>
    <div>
        <ul class="nav nav-tabs" id="myTab" role="tablist">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                <li class="nav-item" role="presentation">
                    <a class="nav-link" :class="{ active: activeTab == 0 }" @click="activeTab = 0" id="allotment-tab"
                       data-toggle="tab" href="#allotment" role="tab" aria-controls="allotment"
                       aria-disabled="true">{{ t('NAV.USER') }}</a>
                </li>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                <li class="nav-item" role="presentation">
                    <a class="nav-link" :class="{ active: activeTab == 1 }" @click.stop.prevent="validateSecondAbaClick"
                       id="localization-tab" data-toggle="tab" href="#localization" role="tab"
                       aria-controls="localization"
                       aria-disabled="true">{{ t('GENERAL.PERMISSIONS') }}</a>
                </li>
            </div>
        </ul>
        <form @submit.prevent="create">
            <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade" :class="{ active: activeTab == 0, show: activeTab == 0 }" id="allotment"
                     role="tabpanel" aria-labelledby="allotment-tab">

                    <div class="modal-body">
                        <div class="row gutters">
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-1">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="active"
                                           v-model="user.active">
                                    <label class="custom-control-label" for="active">{{ t('ALLOTMENT.ACTIVE') }}</label>
                                </div>
                            </div>
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <div class="form-group">
                                    <label for="name" class="required">{{ t('GENERAL.NAME') }}: </label>
                                    <input type="text" id="name" name="name" v-model="user.name" class="form-control"
                                           @keyup="inputName(user.name)" placeholder="Nome Completo">
                                    <div v-if="isNameInvalid" class="validation">{{ t(msgError) }}</div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                                <div class="form-group">
                                    <label for="email" class="required">{{ t('GENERAL.EMAIL') }}: </label>
                                    <input type="text" id="email" name="email" v-model="user.email" class="form-control"
                                           @keyup="clearMail()" placeholder="Endereço de e-mail">
                                    <div class="validation" id="invalidEmail" style="display: none">{{ msgEmail }}</div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                                <div class="form-group">
                                    <label for="email">{{ t('GENERAL.CRECI') }}: </label>
                                    <input type="text" id="creci" name="creci" v-model="user.creci" class="form-control"
                                    >
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                                <div class="form-group">
                                    <label class="required" for="taxpayer">{{ t('COMPANIES.TAXPAYER') }}:</label>
                                    <input type="text" id="taxpayer" name="taxpayer" v-model="user.taxpayer"
                                           @keyup="inputTaxpayer(user.taxpayer)" onpaste="return false"
                                           ondrop="return false" class="form-control"
                                           placeholder="000.000.000-00"
                                            v-mask="['###.###.###-##', 'XX.XXX.XXX/XXXX-##']">
                                    <div v-if="isTaxpayerInvalid" class="validation">{{ t(msgTaxpayer) }}</div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                                <div class="form-group">
                                    <label for="birthdate">{{
                                            (user?.taxpayer?.length > 14) ? t('COMPANIES.BIRTHDATE_COMAPANY') : t('COMPANIES.BIRTHDATE')
                                        }}:</label>
                                    <input type="date" id="birthdate" name="birthdate" v-model="user.birthday"
                                           class="form-control" @blur="validateDateMin">
                                </div>
                            </div>
                        </div>
                        <div class="row gutters">
                            <div class="col-xl-12 col-lglg-12 col-md-12 col-sm-12 col-12">
                                <phone :phonesIndex="phones" @update="updatePhone($event)" required></phone>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="tab-pane fade" :class="{ active: activeTab == 1, show: activeTab == 1 }" id="localization"
                     role="tabpanel" aria-labelledby="localization-tab">

                    <div class="row gutters">
                        <div class="col-6">
                            <div class="form-group">
                                <label for="">Companhia</label>
                                <input disabled type="text" v-model="company.text" class="form-control">
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label :for="'profile'+company.id" class="required">Grupo</label>
                                <Select2
                                        :settings="{ width: '100%', placeholder: t('GENERAL.MSG.SELECT_ONE', {article: 'um', name: t('GENERAL.GRUP')})}"
                                        :options="profiles" v-model="company.group_id"
                                        :id="'profile'+company.id"
                                        :name="'profile'+company.id"
                                        @select="selectProfile($event, key, company, user.active), selectGeneric(company.group_id, company.id)"/>
                                <div class="validation" :id="'invalid'+company.id" style="display: none">
                                    {{ t('GENERAL.MSG.REQUIRED_FIELD') }}
                                </div>
                            </div>
                        </div>
                        <div class="col-12">

                        </div>
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <table class="table table-hover table-bordered" id="company">
                                <thead>
                                <tr>
                                    <th class="text-center">Selecionar</th>
                                    <th class="text-center">Loteamento</th>
                                    <th class="text-center">Imobiliaria</th>
                                    <th class="text-center">Corretagem</th>
                                    <th class="text-center">Qtd. Reservas</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="allotment in company.allotments" :key="allotment.id">
                                    <td class="text-center">
                                        <div class="custom-control custom-switch">
                                            <input data-cy="user_add_allotment" type="checkbox"
                                                   class="custom-control-input"
                                                   :id="'customCheck'+allotment.id" v-model="allotment.check"
                                                   @click="selectAllotment(allotment)">
                                            <label class="custom-control-label"
                                                   :for="'customCheck'+allotment.id"></label>
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <p> {{ allotment.text }}</p>
                                    </td>
                                    <td class="text-center">
                                        <select2 :settings="ajaxPerson"
                                                 :disabled="!allotment.check"
                                                 :placeholder="allotment.real_estate_agency_name ? allotment.real_estate_agency_name : 'Selecione'"
                                                 @select="selectImobi($event, allotment, allotment.id)"
                                        ></select2>
                                    </td>
                                    <td class="text-center">
                                        <div class="input-group align-self-center">
                                            <input class="form-control" type="text" id="brokerage"
                                                   name="brokerage"
                                                   :disabled="!allotment.check"
                                                   v-model.lazy="allotment.brokerage_value"
                                                   @focusout="setValueInAllotmentGroup(allotment.id, company.id, allotment)"
                                                   v-money3="this.configBrokerage[allotment.id]">
                                            <div class="input-group-prepend">
                                                <button class="btn btn-outline-secondary dropdown-toggle"
                                                        type="button"
                                                        :disabled="!allotment.check"
                                                        data-toggle="dropdown" aria-haspopup="true"
                                                        aria-expanded="false">
                                                    {{ t('GENERAL.TYPE') }}
                                                </button>
                                                <div class="dropdown-menu dropdown-menu-right">
                                                    <a class="dropdown-item bg-hover-white"
                                                       @click="resetConfigBrokerage(allotment, false)">{{
                                                            t('GENERAL.REAIS')
                                                        }}</a>
                                                    <a class="dropdown-item bg-hover-white"
                                                       @click="resetConfigBrokerage(allotment, true)">{{
                                                            t('GENERAL.PERCENTAGE')
                                                        }}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <input data-cy="user_create_max_reserve" type="text" id="maxReserves"
                                               name="maxReserves"
                                               v-model="allotment.max_number_reserves"
                                               class="form-control" :placeholder="t('GENERAL.QUANTITY_MAX_RESERVE')"
                                               @keyup="inputGeneric(allotment.max_number_reserves, 'maxReserves'),
                        selectMaxReserve(company.id, allotment.id, allotment.max_number_reserves)"
                                               :disabled="!allotment.check">
                                        <div class="validation" id="invalidmaxReserves" style="display: none">
                                            {{ t('GENERAL.MSG.REQUIRED_FIELD') }}
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer" style="justify-content: space-between">
                <div>
                    <h5 class="ml-3" style="color: red; font-size: .7rem;">{{ t('GENERAL.REQUIRED_FIELDS') }} *</h5>
                </div>
                <div>
                    <button data-cy="user_create_close" class="btn btn-secondary mr-2" data-dismiss="modal"
                            type="button">
                        {{ t('ACTIONS.CLOSE') }}
                    </button>
                    <button data-cy="user_create_next" class="btn btn-primary" type="button" v-if="activeTab == 0"
                            @click="validateSecondAbaClick()">{{ t('ALLOTMENT.NEXT') }}
                    </button>
                    <button data-cy="user_create_save" class="btn btn-primary" type="submit" v-if="activeTab == 1">
                        {{ t('ACTIONS.SAVE') }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>

import {useI18n} from "vue-i18n";
import User from '@/services/user';
import avatar from "@/../public/avatar.png";
import {useToast} from "vue-toastification";
import Select2 from 'vue3-select2-component';
import Validate from '@/components/validate.vue';
import phone from '@/components/layouts/phoneComponent.vue';
import {Money3Directive} from 'v-money3';

export default {
    name: 'createUsers',
    props: ['userIndex', 'profilesIndex', 'companyIndex'],
    mixins: [Validate],
    directives: {money3: Money3Directive},
    components: {
        phone,
        Select2,
    },
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    data() {
        return {
            user: [],
            phones: [],
            profiles: [],
            activeTab: 0,
            company: {},
            allotments: null,
            userCompaniesGroups: {},
            configBrokerage: [],
            ajaxPerson: {
                width: '200px',
                language: {
                    inputTooShort: function () {
                        return "Por favor, insira ao menos 1 caracteres para pesquisar.";
                    },
                    noResults: function () {
                        return "Nenhum resultado encontrado!";
                    }
                },
                minimumInputLength: 1,
                ajax: {
                    url: `${process.env.VUE_APP_BACK_END}/api/v1/clientes/list?onlyRealState=true`,
                    dataType: "json",
                    headers: {
                        'authorization': `Bearer ${localStorage.getItem('access_token')}`,
                        'company-id': localStorage.getItem('companyId'),
                    },
                    data: params => {
                        return {
                            term: params.term,
                        };
                    },
                    processResults: function (data) {
                        if (!(data.validations)) {
                            data.unshift({id: 0, text: "Nenhum"});
                            return {
                                results: data.map((i) => ({id: i.id, text: i.text}))
                            };
                        } else {
                            return {results: {id: 0, text: "Nenhum"}};
                        }
                    },
                    cache: true
                },
                initSelection: function (element, callback) {
                    callback({id: 1, text: 'initSelection test'});
                },
            },
        }
    },
    mounted() {
        this.user = this.userIndex.user;
        if (this.user.brokerage_is_percentage === undefined) this.user.brokerage_is_percentage = true;
        this.profiles = this.profilesIndex;
        this.indexCompany();
    },
    emits:['create'],
    watch: {
        userIndex: function () {
            this.phones = [];
            this.activeTab = 0;
            this.user = this.userIndex.user;
            if (this.user.brokerage_is_percentage === undefined) this.user.brokerage_is_percentage = true;
            this.userCompaniesGroups = null;
            this.indexCompany();
            this.removeValidationsOpen();
        }
    },
    methods: {
        validateDateMin() {
            if (!this.user.birthday) return;
            const dataSelecionada = new Date(this.user.birthday);
            const year = dataSelecionada.getFullYear();
            if (year && year < 1900) {
                dataSelecionada.setFullYear(1900);
                const ano = dataSelecionada.getFullYear();
                const mes = String(dataSelecionada.getMonth() + 1).padStart(2, '0');
                const dia = String(dataSelecionada.getDate()).padStart(2, '0');
                this.user.birthday = `${ano}-${mes}-${dia}`;
            }
        },
        selectImobi({id, text}, allotment, allotment_id) {
            if (text === 'Nenhum') {
                this.userCompaniesGroups.allotments.forEach(allo => {
                    if (allo.id == allotment_id) {
                        allo.real_estate_agency_id = null;
                        allo.real_estate_agency_name = null;
                        allotment.real_estate_agency_id = null;
                        allotment.real_estate_agency_name = null;
                    }
                });
            } else {
                this.userCompaniesGroups.allotments.forEach(allo => {
                    if (allo.id == allotment_id) {
                        allo.real_estate_agency_id = id;
                        allo.real_estate_agency_name = text;
                        allotment.real_estate_agency_id = id;
                        allotment.real_estate_agency_name = text;
                    }
                });
            }
        },
        async indexCompany() {
            this.company = {
                id: this.companyIndex.id,
                text: this.companyIndex.text,
                group_id: null,
                allotments: this.companyIndex.allotments
            }
            this.companyIndex.allotments.forEach(i => {
                this.configBrokerage[i.id] = {
                    max: 100,
                    prefix: '',
                    decimal: '.',
                    thousands: '',
                    suffix: '%',
                    disabled: false,
                    minimumNumberOfCharacters: 0,
                }
            });
        },
        setValueInAllotmentGroup(allotment_id, company_id, allotmentIndex) {
            this.userCompaniesGroups.allotments.forEach(allotment => {
                if (allotment.id == allotment_id) {
                    allotment.brokerage_value = allotmentIndex.brokerage_value;
                    allotment.brokerage_is_percentage = allotmentIndex.brokerage_is_percentage;
                }
            });
        },
        resetConfigBrokerage(allotment, type) {
            allotment.brokerage_value = 0;
            allotment.brokerage_is_percentage = type;
            this.setConfigBrokerage(allotment.id, type);
        },
        setConfigBrokerage(id, type) {
            if (type) {
                this.configBrokerage[id].max = 100;
                this.configBrokerage[id].prefix = '';
                this.configBrokerage[id].decimal = '.';
                this.configBrokerage[id].thousands = '';
                this.configBrokerage[id].suffix = '%';
                this.configBrokerage[id].disabled = false;
                this.configBrokerage[id].minimumNumberOfCharacters = 0;
            } else {
                this.configBrokerage[id].suffix = '';
                this.configBrokerage[id].decimal = ',';
                this.configBrokerage[id].thousands = '.';
                this.configBrokerage[id].prefix = 'R$ ';
                this.configBrokerage[id].disabled = false;
                this.configBrokerage[id].max = 100000000000;
                this.configBrokerage[id].minimumNumberOfCharacters = 1;
            }
        },
        clearMail() {
            if (this.user.email) {
                this.user.email = this.user.email.trim();
                this.user.email = this.user.email.toLowerCase();
            }
            this.inputEmail(this.user.email);
        },
        selectProfile({id}, key, company, active) {
            this.userCompaniesGroups.group_id = id;
            this.userCompaniesGroups.company_id = company.id;
            this.userCompaniesGroups.active = active;
        },
        create() {
            if (this.checkUser()) {
                if (this.valitePermissionSelect()) {
                    this.user.is_password_generic = true;
                    this.$store.commit('changeLoading', true);
                    this.user.avatar = avatar;
                    let user = {
                        user: this.user,
                        userCompaniesGroups: this.userCompaniesGroups
                    }
                    user.userCompaniesGroups.allotments.forEach(item => {
                        let brokerageValueFinal = null;
                        if (item.brokerage_is_percentage || item.brokerage_is_percentage === undefined && item.brokerage_value) {
                            brokerageValueFinal = item.brokerage_value.replaceAll("%", "");
                            brokerageValueFinal = brokerageValueFinal.replaceAll(",", ".");
                            if (brokerageValueFinal > 100) {
                                brokerageValueFinal = 100;
                            }
                        } else if (item.brokerage_value) {
                            brokerageValueFinal = item.brokerage_value.replaceAll("R$ ", "");
                            brokerageValueFinal = item.brokerage_value.replaceAll("%", "");
                            brokerageValueFinal = brokerageValueFinal.replaceAll(".", "");
                            brokerageValueFinal = brokerageValueFinal.replaceAll(",", ".");
                        }
                        item.brokerage_value = brokerageValueFinal;
                    })
                    User.create(user).then(() => {
                        document.getElementById('closeX').click();
                        this.toast.success(this.t('GENERAL.MSG.REGISTER_SUCCESS'));
                        this.$emit('create');
                        this.$store.commit('changeLoading', false);
                    }).catch(error => {
                        this.$store.commit('changeLoading', false);
                        this.errorMsg(error);
                    });
                }
            }
        },
        checkUser() {
            this.invalid = [];
            this.nameValidate(this.user.name);
            this.emailValidate(this.user.email);
            this.validateTaxpayer(this.user.taxpayer);
            if (this.invalid.length && this.invalid.length > 0) {
                return false;
            }
            if (!this.phones?.length) {
                this.toast.error('Campo Telefone é obrigatorio');
                return false;
            }
            return true;
        },
        selectAllotment(allotment) {
            if (!this.userCompaniesGroups?.allotments?.length) {
                this.userCompaniesGroups.allotments = [];
            }
            if (!this.userCompaniesGroups.allotments.find(i => i.id === allotment.id)) {
                let brokerageValueFinal = null
                if (allotment.brokerage_is_percentage || allotment.brokerage_is_percentage === undefined) {
                    brokerageValueFinal = allotment.brokerage_value.replaceAll("%", "");
                    brokerageValueFinal = brokerageValueFinal.replaceAll(",", ".");
                } else {
                    brokerageValueFinal = allotment.brokerage_value.replaceAll("R$ ", "");
                    brokerageValueFinal = brokerageValueFinal.replaceAll(".", "");
                    brokerageValueFinal = brokerageValueFinal.replaceAll(",", ".");
                }
                this.userCompaniesGroups.allotments.push({
                    'id': allotment.id,
                    'description': allotment.text,
                    'max_number_reserves': allotment.max_number_reserves,
                    'brokerage_is_percentage': allotment.brokerage_is_percentage === undefined ? true : allotment.brokerage_is_percentage,
                    'brokerage_value': brokerageValueFinal,
                });
            } else {
                this.userCompaniesGroups.allotments = this.userCompaniesGroups.allotments.filter(i => i.id !== allotment.id)
            }
        },
        selectMaxReserve(company_id, allotment_id, max_number_reserves) {
            this.userCompaniesGroups.allotments.forEach(allotment => {
                if (allotment.id == allotment_id) {
                    allotment.max_number_reserves = max_number_reserves;
                }
            });
        },
        valitePermissionSelect() {
            let invalid = false;
            if (!this.userCompaniesGroups.group_id) {
                invalid = true;
                this.invalid.push(true);
                this.toast.error('Necessário informar um grupo para o usuário');
            }
            if (!this.userCompaniesGroups?.allotments?.length) {
                invalid = true;
                this.invalid.push(true);
                this.toast.error(this.t('GENERAL.MSG.SELECT_ONE_ALLOTMENT_IN_COMPANIES'), {timeout: false});
            }
            return !invalid;
        },
        removeValidationsOpen() {
            this.isNameInvalid = false;
            document.getElementById('name').classList.remove('is-valid');
            document.getElementById('email').classList.remove('is-valid');
            document.getElementById('name').classList.remove('is-invalid');
            document.getElementById('invalidEmail').style.display = 'none';
            document.getElementById('email').classList.remove('is-invalid');
        },
        validateSecondAbaClick() {
            if (this.checkUser()) {
                this.activeTab = 1;
            }
        },
        updatePhone(phones) {
            this.user.phones = phones;
        }
    }
}
</script>

<style scoped>
.btn-holver {
    border: none;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    transition-duration: 0.4s;
    cursor: pointer;
}

.bg-btn {
    background-color: #f2f4f9 !important;
    color: black !important;
}

.bg-btn:hover {
    background-color: #0e5e4e !important;
    color: white !important;
}

.custom-checkbox {
    padding-left: 32px !important;
}

.pointer {
    cursor: pointer;
}
</style>
